import { ReplayMetricsFields, ReplayStop, ReplayStopInput } from '../graphql/types';
import { ReplayRouteDetail } from '../graphql/getReplayRouteDetail';

/** ReplayStop → ReplayStopInput（去掉 stopNo，其余透传） */
export function toStopInput(s: ReplayStop): ReplayStopInput {
    return {
        stop: s.stop,
        streetAddress: s.streetAddress ?? null,
        unit: s.unit ?? null,
        city: s.city ?? null,
        state: s.state ?? null,
        zipCode: s.zipCode ?? null,
        county: s.county ?? null,
        latitude: s.latitude,
        longitude: s.longitude,
    };
}

/** 拼算法/手动顺序的完整入参：起点(-1) → 各停靠 → 终点(-2)，缺失则跳过 */
export function buildOrderedStops(detail: ReplayRouteDetail | null, order: ReplayStop[]): ReplayStopInput[] {
    const arr: ReplayStopInput[] = [];
    if (detail?.startPoint) arr.push(toStopInput(detail.startPoint));
    order.forEach((s) => arr.push(toStopInput(s)));
    if (detail?.endPoint) arr.push(toStopInput(detail.endPoint));
    return arr;
}

export const fmtKm = (v?: number | null) => (v == null ? '—' : `${v.toFixed(1)} km`);
export const fmtDur = (v?: number | null) => {
    if (v == null) return '—';
    const h = Math.floor(v / 60);
    const m = Math.round(v % 60);
    return h > 0 ? `${h}h ${m}m` : `${m}m`;
};
export const fmtCount = (v?: number | null) => (v == null ? '—' : String(v));

/** 手动 vs 算法：距离/时长/转向/红绿灯均「越小越好」 */
export type DiffTone = 'better' | 'worse' | 'even' | 'na';
export interface Diff {
    tone: DiffTone;
    delta: number | null; // manual - algo（负=更优）
}
export function compare(manual?: number | null, algo?: number | null): Diff {
    if (manual == null || algo == null) return { tone: 'na', delta: null };
    const d = manual - algo;
    if (Math.abs(d) < 1e-6) return { tone: 'even', delta: 0 };
    return { tone: d < 0 ? 'better' : 'worse', delta: d };
}

/** 5 指标口径（label + 取值 + 格式化），渲染多处复用 */
export interface MetricSpec {
    key: keyof ReplayMetricsFields;
    labelKey: string; // i18n key（相对 delivery.routeReplay.metric）
    fmt: (v?: number | null) => string;
}
export const METRIC_SPECS: MetricSpec[] = [
    { key: 'totalDistanceKm', labelKey: 'distance', fmt: fmtKm },
    { key: 'totalDurationMinutes', labelKey: 'duration', fmt: fmtDur },
    { key: 'leftTurnCount', labelKey: 'leftTurn', fmt: fmtCount },
    { key: 'uTurnCount', labelKey: 'uTurn', fmt: fmtCount },
    { key: 'trafficLightCount', labelKey: 'trafficLight', fmt: fmtCount },
];
